<template>
  <div class="panelBoxWarp">
    <div class="panelBox" :class="{ on: sidebarShow }">
      <div class="componentList">
        <ul>
          <li
            v-for="(item, index) of componentList"
            :key="index"
            :class="{ on: componentActive == index }"
            @click="componentActive = index"
          >
            <i class="iconfont icon-fangkuai"></i>
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
      <div class="categoryList">
        <div class="itemBox" v-for="(item, index) of categoryList" :key="index">
          <h3>{{ item.title }}</h3>
          <div class="childList">
            <draggable
              class="dragArea list-group"
              :list="item.classList"
              :clone="cloneItem"
              :group="{ name: 'pageEdit', pull: 'clone', put: false }"
              :options="{ sort: false }"
            >
              <div
                @mouseover="hoverItem(classItem)"
                @mouseout="hoverItemOut"
                class="childItem list-group-item"
                v-for="(classItem, index) of item.classList"
                :key="index"
              >
                <div class="contentBox">
                  <img
                    :src="
                      isHover === classItem.title
                        ? classItem.iconH
                        : classItem.icon
                    "
                    alt=""
                  />
                  <span>{{ classItem.title }}</span>
                </div>
                <div class="cloneText">组件放置区域</div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <div
      class="btnToggle"
      @click="sidebarShow = !sidebarShow"
      :class="{ on: sidebarShow }"
    >
      <i class="iconfont icon-arrow-right"></i>
      <i class="iconfont icon-arrow-left"></i>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import imageSrc from '../../assets/canvasImg.js'
export default {
  name: 'panel',
  components: {
    draggable
  },
  data () {
    return {
      sidebarShow: true,
      componentActive: 0,
      componentList: ['组件'],
      categoryList: [
        {
          title: '基础组件',
          classList: [
            {
              title: '店铺头部',
              icon: imageSrc.shopIcon,
              iconH: imageSrc.shopIconH,
              type: 'header',
              componentContent: {
                title: 'Yshop'
              }
            },
            {
              title: '搜索商品',
              icon: imageSrc.shopIcon,
              iconH: imageSrc.shopIconH,
              type: 'search',
              componentContent: {}
            },
            {
              title: '轮播图',
              icon: imageSrc.textIcon,
              iconH: imageSrc.textIconH,
              type: 'banner',
              componentContent: {
                bannerData: [
                  {
                    pic: require('@/assets/images/cereshop/home/banner.png'),
                    name: '0',
                    sort: 0,
                    url: '/',
                    status: 1
                  }
                ]
              }
            },
            {
              title: '滚动新闻',
              icon: imageSrc.brandIcon,
              iconH: imageSrc.brandIconH,
              type: 'noticeBar',
              componentContent: {
                roll: [
                  {
                    uniapp_url: '/pages/shop/news/NewsList/index',
                    url: '/news_list',
                    info:
                      'yshop基于springboot2+Mybatisplus商城系统，3.0版本重构了代码，新增了运费模板、sku单独管理、商品券等',
                    wxapp_url: '/pages/shop/news/NewsList/main'
                  }
                ]
              }
            },
            {
              title: '菜单',
              icon: imageSrc.textImgIcon,
              iconH: imageSrc.textImgIconH,
              type: 'menu',
              componentContent: {
                menus: [
                  {
                    imageArr: [
                      'https://image.dayouqiantu.cn/5e85bfa61251d.png'
                    ],
                    uniapp_url: '/pages/shop/GoodsList/index',
                    name: '全部商品',
                    id: 180,
                    pic: 'https://image.dayouqiantu.cn/all.png',
                    sort: 9,
                    url: '/goods_list',
                    wxapp_url: '/pages/shop/GoodsClass/main',
                    status: 1
                  },
                  {
                    imageArr: ['https://image.dayouqiantu.cn/news.png'],
                    uniapp_url: '/pages/shop/news/NewsList/index',
                    name: '图文资讯',
                    id: 196,
                    pic: 'https://image.dayouqiantu.cn/xw.png',
                    sort: 8,
                    url: '/news_list',
                    wxapp_url: '/pages/shop/news/NewsList/main',
                    status: 1
                  },
                  {
                    imageArr: [
                      'https://image.dayouqiantu.cn/5e4e939507b5e.png'
                    ],
                    uniapp_url: '/pages/shop/GoodsCollection/index',
                    name: '我的收藏',
                    id: 197,
                    pic: 'https://image.dayouqiantu.cn/colle.png',
                    sort: 7,
                    url: '/collection',
                    wxapp_url: '/pages/shop/GoodsCollection/main',
                    status: 1
                  },
                  {
                    imageArr: ['https://image.dayouqiantu.cn/coupon.png'],
                    uniapp_url: '',
                    name: '优惠券',
                    id: 199,
                    pic: 'https://image.dayouqiantu.cn/cou.png',
                    sort: 6,
                    url: '/user/get_coupon',
                    wxapp_url: '/pages/user/coupon/GetCoupon/main',
                    status: 1
                  },
                  {
                    imageArr: ['https://image.dayouqiantu.cn/pink.png'],
                    uniapp_url: '/pages/activity/GoodsGroup/index',
                    name: '拼团专区',
                    id: 200,
                    pic:
                      'https://image.dayouqiantu.cn/62ac09d2914d36c65b9b59d2147d809a.png',
                    sort: 5,
                    url: '/activity/group',
                    wxapp_url: '/pages/activity/GoodsGroup/main',
                    status: 1
                  },
                  {
                    imageArr: ['https://image.dayouqiantu.cn/sign.png'],
                    uniapp_url: '/pages/user/signIn/Sign/index',
                    name: '积分签到',
                    id: 209,
                    pic:
                      'https://image.dayouqiantu.cn/29ea4acebbf99e7eaf6f85af2b6d79ae.png',
                    sort: 4,
                    url: '/user/sign',
                    wxapp_url: '/pages/user/signIn/Sign/main',
                    status: 1
                  },
                  {
                    imageArr: ['https://image.dayouqiantu.cn/sekill.png'],
                    uniapp_url: '/pages/activity/GoodsSeckill/index',
                    name: '秒杀专区',
                    id: 216,
                    pic:
                      'https://image.dayouqiantu.cn/b0344c148141b50d68db9722708ea49e.png',
                    sort: 3,
                    url: '/activity/goods_seckill',
                    wxapp_url: '/pages/activity/GoodsSeckill/main',
                    status: 1
                  },
                  {
                    imageArr: ['https://image.dayouqiantu.cn/bargin.png'],
                    uniapp_url: '/pages/activity/GoodsBargain/index',
                    name: '砍价专区',
                    id: 217,
                    pic: 'https://image.dayouqiantu.cn/bar.png',
                    sort: 2,
                    url: '/activity/bargain',
                    wxapp_url: '/pages/activity/GoodsBargain/main',
                    status: 1
                  }
                ]
              }
            },
            {
              title: '广告',
              icon: imageSrc.twListIcon,
              iconH: imageSrc.twListIconH,
              type: 'adv',
              componentContent: {
                detail: {
                  list: [
                    {
                      image: 'https://wx.yixiang.co/static/images/index001.png',
                      url: '',
                      uniapp_url: '',
                      wxapp_url: '',
                      path_type: 1
                    },
                    {
                      image: 'https://wx.yixiang.co/static/images/index002.png',
                      url: '',
                      uniapp_url: '',
                      wxapp_url: '',
                      path_type: 1
                    },
                    {
                      image: 'https://wx.yixiang.co/static/images/index003.png',
                      url: '',
                      uniapp_url: '',
                      wxapp_url: '',
                      path_type: 1
                    }
                  ],
                  name: '',
                  style: 3
                }
              }
            },
            {
              title: '超值拼团',
              icon: imageSrc.customIcon,
              iconH: imageSrc.customIconH,
              type: 'groupon',
              componentContent: {}
            },
            {
              title: '热门榜单',
              icon: imageSrc.customIcon,
              iconH: imageSrc.customIconH,
              type: 'hotCommodity',
              componentContent: {}
            },
            {
              title: '秒杀',
              icon: imageSrc.videoIcon,
              iconH: imageSrc.videoIconH,
              type: 'firstNewProduct',
              componentContent: {}
            },
            {
              title: '精品推荐',
              icon: imageSrc.videoIcon,
              iconH: imageSrc.videoIconH,
              type: 'productsRecommended',
              componentContent: {}
            },
            {
              title: '促销单品',
              icon: imageSrc.videoIcon,
              iconH: imageSrc.videoIconH,
              type: 'promoteProduct',
              componentContent: {}
            },
            {
              title: '直播',
              icon: imageSrc.videoIcon,
              iconH: imageSrc.videoIconH,
              type: 'live',
              componentContent: {}
            },
            {
              title: '为您推荐',
              icon: imageSrc.videoIcon,
              iconH: imageSrc.videoIconH,
              type: 'promotionGood',
              componentContent: {}
            }
          ]
        }
      ],
      isHover: ''
    }
  },
  mounted () {},
  methods: {
    hoverItem (classItem) {
      this.isHover = classItem.title
    },
    hoverItemOut () {
      this.isHover = ''
    },
    cloneItem (item) {
      return JSON.parse(JSON.stringify(item))
    }
  }
}
</script>

<style lang="scss" scoped>
.panelBoxWarp {
  position: relative;
  height: 100%;
}

.panelBox {
  width: 0px;
  min-height: 100%;
  display: flex;
  overflow: hidden;
  transition: 0.2s width ease;

  &.on {
    width: 250px;
  }

  .componentList {
    width: 64px;
    padding: 17px 0;
    text-align: center;

    li {
      position: relative;
      margin-bottom: 18px;

      .iconfont {
        font-size: 24px;
      }

      span {
        font-size: 12px;
        display: block;
      }

      &.on,
      &:hover {
        color: $mainColor;

        :after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 2px;
          height: 100%;
          background-color: $mainColor;
        }
      }
    }
  }

  .categoryList {
    border-left: 1px solid #f0f3f4;
    width: 186px;
    padding: 20px 0;

    .itemBox {
      h3 {
        padding-left: 20px;
        height: 35px;
        line-height: 35px;
        font-size: 16px;
        color: #333333;
        position: relative;

        &:before {
          content: "";
          border-left: 5px solid $mainColor;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
          position: absolute;
          left: 10px;
          top: 50%;
          margin-top: -4px;
        }
      }

      .childList {
        font-size: 14px;
        color: #333333;
        padding: 20px 10px;

        .list-group {
          display: flex;
          flex-wrap: wrap;

          :hover {
            background: #ff7800;
            color: #ffffff;
            border-radius: 3px;
            cursor: move;
          }

          .childItem {
            height: 80px;
            width: 50%;
            cursor: pointer;

            .contentBox {
              height: 100%;
              display: flex;
              flex-flow: column;
              align-items: center;
              justify-content: center;

              img {
                width: 20px;
                height: 20px;
              }

              span {
                margin-top: 10px;
              }
            }

            .cloneText {
              display: none;
            }
          }
        }
      }
    }
  }
}

.btnToggle {
  width: 20px;
  height: 66px;
  background-color: #fff;
  border-radius: 0 20px 20px 0;
  position: absolute;
  right: -20px;
  top: 50%;
  margin-top: -33px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 9;

  .icon-arrow-left {
    display: none;
  }

  &.on {
    .icon-arrow-left {
      display: block;
    }

    .icon-arrow-right {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/leftBar/panel.vue